import { render, staticRenderFns } from "./FriendsTab.vue?vue&type=template&id=37e5c290&scoped=true"
import script from "./FriendsTab.vue?vue&type=script&lang=ts"
export * from "./FriendsTab.vue?vue&type=script&lang=ts"
import style0 from "./FriendsTab.vue?vue&type=style&index=0&id=37e5c290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5c290",
  null
  
)

export default component.exports